import { BASE_PATH } from '../store';
import { getValidAccessToken } from '../store/oauth-browser';
import type { OrganizationDevice } from './organization-devices-types';

/**
 * Henter enheter med sync-status for organisasjonen, fra
 * GET /organizations/{organizationId}/devices (dabih-api#4786).
 * Endepunktet er begrenset til kontoeier; alle feil gir tom liste.
 */
export async function fetchOrganizationDevices(organizationId: number): Promise<OrganizationDevice[]> {
  try {
    const token = await getValidAccessToken();
    if (!token) {
      return [];
    }
    const response = await fetch(`${BASE_PATH}/organizations/${organizationId}/devices`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      return [];
    }
    const data = await response.json();
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}
